export const buildFlyBundlesPayload = (
  items: Array<{ variantId: number; quantity: number }>,
  flyOfferId: string,
  flySectionId: string
): ShopifyCartAddPayload & { 'section-id': string } => {
  return {
    items: items.map(({ variantId, quantity }) => ({
      id: variantId,
      quantity,
      properties: {
        '_flyBundles:OfferId': flyOfferId,
        '_flyBundles:prodQty': String(quantity),
        '_flyBundles:customField': ''
      }
    })),
    'section-id': flySectionId
  };
};

// Deterministic short hash of a kit's resolved variant selection, so repeat
// add-to-cart calls with the SAME selection produce the same FlyBundles
// offer ID (and merge), while a DIFFERENT selection still gets a distinct one.
export const hashKitVariantSelection = (
  items: Array<{ variantId: number; quantity: number }>
): string => {
  const signature = [...items]
    .sort((a, b) => a.variantId - b.variantId)
    .map(({ variantId, quantity }) => `${variantId}:${quantity}`)
    .join('|');

  let hash = 0;
  for (let i = 0; i < signature.length; i++) {
    hash = (hash * 31 + signature.charCodeAt(i)) | 0;
  }

  return Math.abs(hash).toString(36);
};
